(() => {
  const root = document.querySelector('[data-builder]');
  if (!root) return;
  const panels = [...root.querySelectorAll('[data-builder-panel]')];
  const tabs = [...root.querySelectorAll('[data-builder-step]')];
  const selected = new Map(), data = new Map(), pages = new Map();
  const labels = JSON.parse(root.querySelector('[data-builder-labels]').textContent);
  const tagsByKind = {sub: 'slz-build-subwoofer', amp: 'slz-build-amplifier', speaker: 'slz-build-speaker', wire: 'slz-build-wiring', accessory: 'slz-build-accessory'};
  let active = 0, busy = false;
  const text = (key, values = {}) => Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll('%' + name + '%', replacement), labels[key] || key);
  const money = value => new Intl.NumberFormat(SoundLabz.locale, {style: 'currency', currency: SoundLabz.currency}).format(value / 100);
  const el = (tag, value, cls) => {
    const node = document.createElement(tag);
    if (value !== undefined) node.textContent = value;
    if (cls) node.className = cls;
    return node;
  };
  const productTags = product => Array.isArray(product.tags) ? product.tags : typeof product.tags === 'string' ? product.tags.split(',').map(tag => tag.trim()) : [];
  const eligible = (product, panel) => Boolean(tagsByKind[panel.dataset.stepKind]) && productTags(product).includes(tagsByKind[panel.dataset.stepKind]);
  const productImage = product => {
    for (const image of [product.image, product.featured_image, product.images?.[0]]) {
      if (typeof image === 'string' && image) return image;
      if (typeof image?.src === 'string' && image.src) return image.src;
    }
    return undefined;
  };
  const normalize = product => ({
    ...product,
    tags: productTags(product),
    image: productImage(product),
    variants: (product.variants || []).map(variant => ({...variant, price: typeof variant.price === 'string' ? Math.round(Number(variant.price) * 100) : variant.price}))
  });
  const chosenProduct = (index, choice) => data.get(index)?.find(product => product.handle === choice.handle && eligible(product, panels[index]));
  const selectionValid = (index, choice) => {
    const product = chosenProduct(index, choice);
    return Boolean(product?.variants.some(variant => String(variant.id) === String(choice.variantId) && variant.available !== false));
  };
  const ready = () => selected.size > 0 && [...selected].every(([index, choice]) => selectionValid(index, choice)) && !panels.some((panel, index) => panel.dataset.required === 'true' && !selected.has(index));
  async function liveProduct(handle) {
    if (!/^[a-z0-9-]+$/.test(handle)) throw Error(text('ineligible'));
    const response = await fetch(SoundLabz.root + 'products/' + handle + '.js', {cache: 'no-store'});
    if (!response.ok) throw Error(text('unavailable'));
    return normalize(await response.json());
  }
  function remember(index, product) {
    const products = data.get(index);
    const existing = products.findIndex(item => item.handle === product.handle);
    if (existing < 0) products.push(product);
    else products[existing] = product;
  }
  panels.forEach((panel, index) => {
    data.set(index, JSON.parse(panel.querySelector('[data-builder-products]').textContent).map(normalize).filter(product => eligible(product, panel)));
    pages.set(index, 0);
    render(index);
    panel.querySelector('[data-builder-more]').hidden = !panel.dataset.collectionUrl;
  });
  function render(index) {
    const panel = panels[index], list = panel.querySelector('[data-builder-options]');
    const query = panel.querySelector('[data-builder-search]').value.toLowerCase();
    const excluded = (panel.dataset.exclude || '').toLowerCase().split(',').map(term => term.trim()).filter(Boolean);
    const products = data.get(index).filter(product => eligible(product, panel) && product.title.toLowerCase().includes(query) && !excluded.some(term => product.title.toLowerCase().includes(term)));
    list.replaceChildren();
    for (const product of products) {
      const card = el('article', undefined, 'builder-choice');
      card.dataset.product = product.handle;
      const current = selected.get(index);
      card.classList.toggle('is-selected', current?.handle === product.handle);
      if (product.image) {
        const image = el('img');
        image.src = product.image; image.alt = product.title; image.width = 300; image.height = 300; image.loading = 'lazy';
        card.append(image);
      }
      card.append(el('strong', product.title));
      const select = el('select');
      select.setAttribute('aria-label', text('variant_for', {title: product.title}));
      for (const variant of product.variants) {
        const option = el('option', variant.title + (variant.available === false ? ' · ' + text('sold_out') : ''));
        option.value = variant.id; option.disabled = variant.available === false;
        select.append(option);
      }
      const first = product.variants.find(variant => variant.available !== false);
      if (first) select.value = first.id;
      if (current?.handle === product.handle) select.value = current.variantId;
      const price = el('span', money((product.variants.find(variant => String(variant.id) === select.value) || product.variants[0])?.price || 0));
      select.addEventListener('change', () => {
        const variant = product.variants.find(item => String(item.id) === select.value);
        if (variant) price.textContent = money(variant.price);
      });
      const button = el('button', current?.handle === product.handle ? text('selected') : text('choose'), 'btn btn-outline');
      button.disabled = !first;
      button.addEventListener('click', async () => {
        if (!eligible(product, panel)) return;
        const error = panel.querySelector('[data-builder-error]');
        button.disabled = true; error.textContent = '';
        try {
          const fresh = await liveProduct(product.handle);
          if (!eligible(fresh, panel)) throw Error(text('ineligible'));
          const variant = fresh.variants.find(item => String(item.id) === select.value && item.available);
          if (!variant) throw Error(text('unavailable'));
          remember(index, fresh);
          selected.set(index, {variantId: variant.id, title: fresh.title, variant: variant.title, price: variant.price, quantity: 1, handle: fresh.handle});
          render(index); summary();
        } catch (problem) {
          error.textContent = problem.message;
        } finally {
          button.disabled = !first;
        }
      });
      card.append(select, price, button); list.append(card);
    }
    if (!products.length) list.append(el('p', query ? text('no_matches') : text('empty'), 'muted'));
  }
  function summary() {
    const list = root.querySelector('[data-builder-summary]');
    list.replaceChildren();
    let total = 0;
    panels.forEach((panel, index) => {
      const choice = selected.get(index), item = el('li');
      item.append(el('strong', panel.dataset.title));
      if (choice) {
        total += choice.price * choice.quantity;
        item.append(el('span', choice.title + ' / ' + choice.variant));
        const quantity = el('div', undefined, 'quantity');
        const minus = el('button', '−');
        minus.setAttribute('aria-label', text('decrease', {title: choice.title}));
        minus.onclick = () => {if (choice.quantity > 1) choice.quantity--; else selected.delete(index); render(index); summary();};
        const count = el('input');
        count.type = 'number'; count.min = '1'; count.max = '99'; count.value = choice.quantity;
        count.setAttribute('aria-label', text('quantity_for', {title: choice.title}));
        count.onchange = () => {choice.quantity = Math.max(1, Math.min(99, parseInt(count.value, 10) || 1)); summary();};
        const plus = el('button', '+');
        plus.setAttribute('aria-label', text('increase', {title: choice.title}));
        plus.onclick = () => {choice.quantity = Math.min(99, choice.quantity + 1); summary();};
        quantity.append(minus, count, plus); item.append(quantity);
        const remove = el('button', text('remove'), 'remove');
        remove.onclick = () => {selected.delete(index); render(index); summary();};
        item.append(remove);
      } else item.append(el('span', panel.dataset.required === 'true' ? text('choose_component') : text('optional')));
      list.append(item);
    });
    root.querySelectorAll('[data-builder-total]').forEach(node => node.textContent = money(total));
    root.querySelector('[data-builder-add]').disabled = busy || !ready();
  }
  function step(index) {
    active = Math.max(0, Math.min(panels.length - 1, index));
    panels.forEach((panel, position) => panel.hidden = position !== active);
    tabs.forEach((tab, position) => {tab.setAttribute('aria-selected', String(position === active)); tab.tabIndex = position === active ? 0 : -1;});
    root.querySelector('[data-builder-back]').disabled = active === 0;
    root.querySelector('[data-builder-skip]').hidden = panels[active].dataset.required === 'true';
    root.querySelector('[data-builder-next]').textContent = (active === panels.length - 1 ? text('review') : text('next')) + ' ↗';
  }
  tabs.forEach((tab, index) => {
    tab.onclick = () => step(index);
    tab.onkeydown = event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); step(active + (event.key === 'ArrowRight' ? 1 : -1)); tabs[active].focus();
      }
    };
  });
  root.querySelector('[data-builder-back]').onclick = () => step(active - 1);
  root.querySelector('[data-builder-skip]').onclick = () => step(active + 1);
  root.querySelector('[data-builder-next]').onclick = () => {
    if (active === panels.length - 1) {
      root.querySelector('#SystemSummary').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block: 'center'});
    } else step(active + 1);
  };
  panels.forEach((panel, index) => {
    panel.querySelector('[data-builder-search]').addEventListener('input', () => render(index));
    panel.querySelector('[data-builder-more]').onclick = async event => {
      const button = event.currentTarget, error = panel.querySelector('[data-builder-error]');
      button.disabled = true; error.textContent = '';
      try {
        const page = pages.get(index) + 1;
        const response = await fetch(panel.dataset.collectionUrl + '/products.json?limit=250&page=' + page);
        if (!response.ok) throw Error(text('load_failed'));
        const result = await response.json(), known = new Set(data.get(index).map(product => product.handle));
        data.get(index).push(...result.products.map(normalize).filter(product => eligible(product, panel) && !known.has(product.handle)));
        pages.set(index, page); button.hidden = result.products.length < 250; render(index);
      } catch (problem) {
        error.textContent = problem.message;
      } finally {
        button.disabled = false;
      }
    };
  });
  root.querySelector('[data-builder-add]').onclick = async () => {
    if (busy || !ready()) return;
    busy = true; summary();
    const error = root.querySelector('[data-builder-add-error]');
    error.textContent = '';
    let added = false;
    try {
      const items = await Promise.all([...selected].map(async ([index, choice]) => {
        const fresh = await liveProduct(choice.handle);
        if (!eligible(fresh, panels[index])) throw Error(text('ineligible'));
        const variant = fresh.variants.find(item => String(item.id) === String(choice.variantId) && item.available);
        if (!variant) throw Error(text('unavailable'));
        return {id: variant.id, quantity: Math.max(1, Math.min(99, parseInt(choice.quantity, 10) || 1)), properties: {_soundlabz_system: 'Custom system'}};
      }));
      const response = await fetch(SoundLabz.root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw Error(result.description || text('add_failed'));
      added = true; await window.slzRefreshCart(); document.querySelector('#CartDialog').showModal();
    } catch (problem) {
      error.textContent = added ? text('added') : problem.message;
    } finally {
      busy = false; summary();
    }
  };
  const params = new URLSearchParams(location.search), handle = params.get('product');
  if (handle && /^[a-z0-9-]+$/.test(handle)) {
    liveProduct(handle).then(product => {
      const index = panels.findIndex(panel => eligible(product, panel));
      if (index < 0) return;
      const variant = product.variants.find(item => String(item.id) === params.get('variant') && item.available) || product.variants.find(item => item.available);
      if (!variant) return;
      remember(index, product);
      selected.set(index, {variantId: variant.id, title: product.title, variant: variant.title, price: variant.price, quantity: 1, handle: product.handle});
      summary(); render(index); step(Math.min(index + 1, panels.length - 1));
    }).catch(() => {});
  }
  step(0); summary();
})();
